import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import subscriptionPlanService from "../../services/subscriptionPlanService";

export const fetchSubscriptionPlans = createAsyncThunk(
  "subscriptionPlans/fetchSubscriptionPlans",
  async () => {
    return await subscriptionPlanService.getSubscriptionPlans();
  },
);

export const addSubscriptionPlan = createAsyncThunk(
  "subscriptionPlans/addSubscriptionPlan",
  async (planData) => {
    return await subscriptionPlanService.createSubscriptionPlan(planData);
  },
);

export const removeSubscriptionPlan = createAsyncThunk(
  "subscriptionPlans/removeSubscriptionPlan",
  async (id) => {
    await subscriptionPlanService.deleteSubscriptionPlan(id);
    return id;
  },
);

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlans",
  initialState: {
    plans: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscriptionPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = action.payload;
      })
      .addCase(fetchSubscriptionPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addSubscriptionPlan.fulfilled, (state, action) => {
        state.plans.push(action.payload);
      })
      .addCase(removeSubscriptionPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeSubscriptionPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans = state.plans.filter((p) => p.plan_id !== action.payload);
      })
      .addCase(removeSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default subscriptionPlanSlice.reducer;
